import styled from 'styled-components'
import { mobileL } from '../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const SoftApply = styled.div`
  .dropzone {
    border: 1px dashed #80808061;
    padding: 2rem;
    border-radius: 8px;
    cursor: pointer;
    background-color: white;

    p {
      text-align: center;
    }

    svg {
      margin-bottom: 15px;
    }

    span {
      font-size: 14px;
      font-weight: 400;
      margin-top: 15px;
      display: block;
    }
  }

  aside {
    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      list-style: none;
      padding: 0;
      align-items: center;
    }
  }
`

export const SoftApplyComfirm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${mobileL({
    height: '100vh',
  })}

  .title-already-applied {
    max-width: 600px;
    padding: 25px;
    font-size: 16px;
    line-height: 1.75;
    text-align: center;
    padding-bottom: 20px;
    padding-top: 20px;

    ${mobileL({
      paddingBottom: '4rem',
    })}
  }

  .title {
    max-width: 500px;
    padding: 25px;
    font-size: 20px;
    line-height: 1.75;
    text-align: center;
    padding-bottom: 20px;
    padding-top: 20px;

    ${mobileL({
      padding: '5px',
    })}
  }

  strong {
    background-color: #6a63f6;
    border-radius: 5px;
    padding: 5px;
    color: white;
  }
`
